import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./data";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.4, type: "spring", stiffness: 200, damping: 15 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    data-testid="whatsapp-float-button"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-24 right-5 z-[85] flex h-14 w-14 items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1E3C] shadow-[0_8px_32px_rgba(212,175,55,0.35)] lg:bottom-6 lg:right-6"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#D4AF37]/30" />
    <MessageCircle size={24} className="relative" />
  </motion.a>
);
